<template>
	<div>
		<div div v-if="this.dataLoaded">
			<menu-desktop :menuSelected="this.menuSelected" :company="this.customer" />

			<menu-mobile v-if="this.user && this.customer" :user="this.user" :menuSelected="this.menuSelected"
				:customer="this.customer" />

			<div class="container-right">
				<div class="barTop" :class="menuSelected.dashboard ? 'view' : 'bar-top-white'">
					<div class="logo-mobile" v-if="menuSelected.dashboard">
						<img src="@/assets/images/logo.jpg" />
					</div>
					<div class="menu-white" v-if="menuSelected.dashboard" @click="openMenu(true)">
						<img src="@/assets/images/menu-burger-alb.svg" />
					</div>

					<div class="mobile-nav" v-if="!menuSelected.dashboard">
						<div class="arrow-back" @click="goBack()">
							<img src="@/assets/images/arrow-back.svg" />
						</div>
						<div class="page-title">
							<h3>{{ this.getPageTitle() }}</h3>
						</div>
						<div class="menu-white" @click="openMenu(true)">
							<img src="@/assets/images/menu-burger-gri.svg" />
						</div>
					</div>
					<TopBar v-if="this.user" :user="this.user" />
				</div>

				<div class="content">
					<CompanySearch :customer="this.customer" :user="this.user" v-if="this.company && this.menuSelected.companySearch && this.company.role === 'FAC'
						" />
					<CompanySettings :customer="this.customer" :user="this.user" v-if="this.menuSelected.account" />
					<LinkFrame :urlAddress="this.config.faq" v-if="this.menuSelected.faq" />
					<LinkFrame :urlAddress="this.config.contact" v-if="this.menuSelected.contact" />
					<LinkFrame :urlAddress="this.config.terms" v-if="this.menuSelected.terms" />
				</div>
			</div>
		</div>
		<!-- <div id="modal_popup_loading" class="modal-popup">
			<div class="modal-popup-content" style="width:25% !import">
				<img src="@/assets/images/loading.gif" />
				<p v-html="$t('loadingPopupMessage')"></p>
			</div>
		</div> -->
	</div>
</template>

<script>
import moment from "moment/src/moment";
import MenuDesktop from "@/components/company/customer/MenuDesktop.vue";
import MenuMobile from "@/components/company/customer/MenuMobile.vue";
import TopBar from "@/components/company/TopBar.vue";
import CompanySettings from "@/components/company/CompanySettings.vue";
import LinkFrame from "@/components/beneficiary/LinkFrame.vue";
import CompanySearch from "@/components/company/customer/CompanySearch.vue";
import httpServiceCustomer from "@/http/http-customer.js";
import Cookies from "js-cookie";
import $ from "jquery";
import httpService from "@/http/http-common.js";
import utils from "@/plugins/utils.js";

export default {
	components: {
		MenuDesktop,
		MenuMobile,
		TopBar,
		LinkFrame,
		CompanySettings,
		CompanySearch
	},
	data() {
		return {
			user: null,
			company: null,
			customer: null,
			customerMessages: null,
			menuSelected: {
				faq: false,
				account: false,
				contact: false,
				terms: false,
				companySearch: false
			},
			config: JSON.parse(localStorage.getItem("beneficiary_jsonFile")),
			isOpen: false,
			isOpenNotification: false,
			readMessagesCount: 0,
			dataLoaded: false
		};
	},
	methods: {
		loadMessages() {
			let formData =
				"?user_id=" +
				this.customer.company_id +
				"&lang=" +
				localStorage.language;
			httpServiceCustomer.customerService
				.getMessages(formData, Cookies.get("token"))
				.then(function (response) {
					// handle success
					return response;
				})
				.then(response => {
					// total no of messages X-Up-Count
					// no of read messages
					this.readMessagesCount = response.headers["x-up-count1"]; //["Content-Length"];
					// no of unread messages X-Up-Count2
					this.customerMessages = response.data;
				})
				.catch(function () {
					// handle success
				});
		},
		openMenu(open) {
			if (open) {
				$(".menu-mobile").show();
			} else {
				$(".menu-mobile").hide();
			}
		},
		openUserMenu() {
			this.isOpen = !this.isOpen;
		},
		openNotifications() {
			this.loadMessages();
			this.isOpenNotification = !this.isOpenNotification;
		},
		isReadNotification(message) {
			message.read = true;
			httpServiceCustomer.customerService
				.markMessageAsRead(message, Cookies.get("token"))
				.catch(function () {
					// handle success
				});
		},
		hide() {
			this.isOpen = false;
		},
		hideNotification() {
			this.isOpenNotification = false;
		},
		getPageTitle() {
			if (this.menuSelected.faq) {
				return "FAQ";
			} else if (this.menuSelected.account) {
				return "My Account";
			} else if (this.menuSelected.contact) {
				return "Contact";
			} else if (this.menuSelected.terms) {
				return "Terms and conditions";
			} else if (this.menuSelected.companySearch) {
				return "Company search";
			} else {
				return "";
			}
		},
		logout() {
			utils.logout();
		},
		goBack() {
			window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
		},
		getExpireAmountDateFormat(date) {
			return moment(new Date(date), "YYYY-MM-DD").format("DD MMM YYYY");
		},
		showModalPopup(elementId, show) {
			if (show) {
				document.getElementById(elementId).style.visibility = "visible";
			} else {
				document.getElementById(elementId).style.visibility = "hidden";
			}
		},
		menuInit() {
			this.dataLoaded = true;
			switch (this.$route.name) {

				case "customer_dashboard":
					if (this.company && this.company.role === "FAC") {
						this.menuSelected = { companySearch: true };
					} else {
						this.menuSelected = { dashboard: true };

						this.$router.push({
							name: "customer_dashboard",
						});
						// this.$router.go();
					}
					break;
				case "customer_services":
					this.menuSelected.services = true;
					break;
				case "customer_faq":
					this.menuSelected.faq = true;
					break;
				case "customer_account":
					this.menuSelected.account = true;
					break;
				case "customer_contact":
					this.menuSelected.contact = true;
					break;
				case "customer_terms":
					this.menuSelected.terms = true;
					break;
				case "company_search":
					this.menuSelected.companySearch = true;
					break;
				default:
					if (this.company && this.company.role === "FAC") {
						this.menuSelected = { companySearch: true };
					} else {
						this.menuSelected = { dashboard: true };
						this.$router.push({
							name: "customer_dashboard",
						});
						// this.$router.go();
					}
			}
		},

	},
	mounted() {
		// this.loadCustomerData();
		if (!localStorage.getItem("beneficiary_jsonFile")) {
			httpService.commonsService.getConfigFile(
				localStorage.language,
				"beneficiary"
			);
		}
	},
	created() {
		// this.showModalPopup("modal_popup_loading", true);

		this.user = this.getUserData();
		this.company = JSON.parse(sessionStorage.getItem("selectedCompany"));
		this.customer = this.getCustomerData('cust c',  this.company.role ? 'this.company.role ' : 'CST');
		if (this.user) {
			this.menuInit();
			// this.showModalPopup("modal_popup_loading", false);

		}
	},
	computed: {
		// dataLoaded() {
		// 	return this.$store.state.customerDataLoaded;
		// },
	},
	watch: {
		'$store.state.customerDataLoaded': {
			handler() {
				// update locally relevant data
				if (this.customer == null || this.user == null){
					this.user = this.getUserData();
					this.company = JSON.parse(sessionStorage.getItem("selectedCompany"));
					this.customer = this.getCustomerData('cust w', this.company.role ? 'this.company.role ' : 'CST');
					this.menuInit();
					this.showModalPopup("modal_popup_loading", false);
				}
			}
		}
	}

};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
